import {Multicall,ContractCallResults,ContractCallContext} from 'ethereum-bsc-multicall';
import {getTokenAbi} from '../app/tokenAbi'

const tokenAbi = getTokenAbi()
const allList = [
    '0xF9444C39BbdcC3673033609204f8Da00d1AE3F52',
    '0x68513E24495b9D1D1FeDEE0906872A96858E8Ad2',
    '0x2F25DbD430CdbD1a6eC184c79C56C18918fcc97D',
    '0x1B96B92314C44b159149f7E0303511fB2Fc4774f',
    '0x7561EEe90e24F3b348E1087A005F78B4c8453524',
    '0xc15fa3E22c912A276550F3E5FE3b0Deb87B55aCd',
    '0xBA35b17bD3e993812B0455DFc4d0eAfA41ADE9cb',
    '0xa7687d322Cb9C3CF98679D164B7e45F8eDE837bC',
    '0xDD428EDb5176908ECF740dFa8a57EfbC36B5D5EB',
    '0xA9776B590bfc2f956711b3419910A5Ec1F63153E',
    '0x210C14fbeCC2BD9B6231199470DA12AD45F64D45',
    '0x125a3E00a9A11317d4d95349E68Ba0bC744ADDc4',
    '0xB6443654Db94dBe382782FCD7B0dEB28449Ee0f1',
    '0x59dC0d5B2C993D4E448c0C886F0A6Badb203D26B',
    '0x1d779adBDc65bF45a6D15C625Daac98f1eF3c150',
    '0x942f0167258dCCfCA16d4e2f27A1630cF5679941',
    '0xe00B8109bcB70B1EDeb4cf87914efC2805020995',
    '0x3Ee04Fd83329F165012919102070E6FdC37181c2',
    '0xeF4F66506AAaEeFf6D10775Ad6f994105D8f11b4',
    '0xfD0cCa3974C525477a36AbA59AE1d63BF6084Aa3',
    '0xDf3ec0f20FD61491C54A3528554Ba125e56D9894',
    '0xA919b33BFec9fFF5577F03857e48f8251f219966',
    '0x4C0bCe2bf4390dB5BE0b749d5a27aec4B892dAe0',
    '0x0c54ab9BEd8765958a9B3ac7fd64A264C94F6585',
    '0xd2d495b17Ca6433D224146FDd99319A812695Ccc',
    '0xb9c25e0aE0B604B7454d6bC884b030C82e29e2f2',
    '0x596D992d53dFcef2AA2651FBBA292438d56138fb',
    '0x3f1C0825f8ec6df33a1830EA97616371d508F84b',
    '0x098Afb73F809D8Fe145363F802113E3825d7490C',
    '0xDbF6A6da052cCb1A29a1d86de5FD51aCDAb5B055',
    '0xC434b517288086043CB3F0A7C2f0EB4C37046206',
    '0x5DE72A6fca2144Aa134650bbEA92Cc919244F05D',
    '0x15e83DEb7097366C44ae19bCea106a5041bF88Ed',
    '0xc502B2595f76dD39F41A1FF640a7E439C27Da95F',
    '0xcD433d8befEA6364B50fC8cCC8A2f78a8d687a73',
    '0x8B57F9CB80e4984Df95f80342ed65d8ec0640328',
    '0x33bc7539D83C1ADB95119A255134e7B584cd5c59',
    '0x357264C2C01b854E6361869d18293Fc1445B9759',
    '0x159C3A50515207a2344b1fb1f831921D452ABfA1',
    '0x1fC5bffCf855B9D7897F1921363547681F6847Aa',
    '0x894d67f2800fC204c9B66953F7175f218419a30C',
    '0xA63402f5Ca52D5E7c3441E41a41Ba3445429BB4f',
    '0x346C03fe8BE489baAAc5CE67e817Ff11fb580F98',
    '0xd11327fBB5Cd97e9412f8e430b479D092f4a9C70',
    '0xb95A11A4AfF2a671e0b4DC0c3e4981371A4bDD33',
    '0x4FFd3B8Ba90F5430Cda7f4cc4C0A80dF3Cd0e495',
    '0xE499d2144A8Cf9dc85f92629afC431334a088b1b',
    '0x22aC4bf4A66631F45F23d325a227e3B9Fb647A4e',
    '0x56DeFe2310109624c20c2E985c3AEa63b9718319',
    '0x4dCDDAa11e2BD78951B7811eeB3fDAC941f23eA3',
    '0xb78e0c6aBE96A4cDF584D63BEd3c4a4ed3d409F3',
    '0x94F2E23c7422fa8c5A348a0E6D7C05b0a6C8a5b8',
    '0xC2ac7b7e0C0968d531b95A7dad1eDFF7Cf8586cc',
    '0x8DE5b59C7A1a1e19c6BeD13546E5D093762ab7cf',
    '0x0D3877152BaaC86D42A4123ABBeCd1178d784cC7',
    '0xC1C951802767B6ae45918AD3AcDA6a4937b8fB36',
    '0xA6fC895186914B5621776Ea8dcD5CcdD1f0035d1',
    '0xa00672c2a70E4CD3919afc2043b4b46e95041425',
    '0xF0CAF168dD42B6181d3F11B703E358273b792935',
    '0xB7baC60efe2DC0f4E0Daab34E82c46892a6bAA48',
    '0x3e151Ca82B3686f555c381530732df1cfc3c7890',
    '0xb6b308C9C7C5F5CACe704c86D4dFa4707A69fC87',
    '0xD4c4168846Efd2f3b8e169917713D59213a693b9',
    '0xD481F4eA902e207AAda9Fa093f80d50B19444253',
    '0xc0aF831c4DDe1b1313Da057FB7F5924f79f6087B',
    '0x08fb6740Cc5170e48B2Ad8Cc07422d3302EF5e78',
    '0xe9F6D18263732df2f8b9C2D45b07ca9D3a5dC7cA',
    '0x2a74b7d7d44025Bcc344E7dA80d542e7b0586330',
    '0x607738735F10dA3c7bcAb0FEaa509e6dF6b425F8',
    '0xcd06c743a1628fB02C15946a56037CD7020F3Bd2',
    '0x186269f602A9C7Bbe333d3c1Bb88CC3277cb222A',
    '0xfa3f14c55adaddc2035083146c1cf768bd035e06',
    '0x7e8a6d548a68339481c500f2B56367698A9F7213',
    '0xf5FA8f27B09F9F449955E137d6DadFb9E086E3ac',
    '0xE576ebF57b3776f8892e2dF1787Cb163f41a1242',
    '0x2098fEf7eEae592038f4f3C4b008515fed0d5886',
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    '0xe9e7cea3dedca5984780bafc599bd69add087d56',
]

export const multicall = new Multicall({
    nodeUrl: 'https://bsc-dataseed.binance.org/'
})

export const getWalletContext = (wallet:any) => {
    const walletCallContext: ContractCallContext<{}>[] = allList.map((token, i) => {
        return {
            reference: `getWalletAmounts${i}`,
            contractAddress: `${token}`,
            abi: tokenAbi,
            calls: [
                { 
                    reference: `${token}`, 
                    methodName: 'symbol', 
                    methodParameters: [] 
                }, 
                { 
                    reference: `balanceCall`, 
                    methodName: 'balanceOf', 
                    methodParameters: [wallet] 
                },
                { 
                    reference: `totalSupply`, 
                    methodName: 'totalSupply', 
                    methodParameters: [] 
                },
            ],
            context:{
                address:`${token}`, 
                poolIndex:`${i}`
            }
        }
    });
    
    return multicall.call(walletCallContext).then(response => {
        const results: ContractCallResults = response
        return results
    })
}



